// https://en.wikipedia.org/wiki/List_of_HTTP_status_codes

export default {
    OK : 200,

    BAD_REQUEST : 400,
    UNAUTHORIZED : 401,
    NOT_FOUND : 404,
    NOT_ACCEPTABLE : 406,
    UNPROCESSABLE_ENTITY : 422,
    INTERNAL_SERVER_ERROR : 500

}